<template>
  <div class="error-wrap">
    <section>
      <div class="error-code">
        <h1>운영기간이 아닙니다.</h1>
        <p>운영 기간을 확인 후 다시 이용해 주시기 바랍니다.</p>
      </div>
    </section>
  </div>
</template>

<script>
import '/static/css/error.css'
export default {
  name: 'Shutdown'
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/error/Shutdown.vue